import { uniq } from "lodash-es";

import EmailResourceMetadata from "@mapmycustomers/shared/types/email/EmailResourceMetadata";

interface ObjectWithEmailResourcesMetadata {
  metadata?: { resources?: EmailResourceMetadata[] };
}

const getEmailMetadataResourcesIds = (
  arg: ObjectWithEmailResourcesMetadata | ObjectWithEmailResourcesMetadata[]
) => {
  return uniq(
    (Array.isArray(arg) ? arg : [arg]).flatMap((object) =>
      (object.metadata?.resources ?? []).map(({ id }) => id)
    )
  );
};

export default getEmailMetadataResourcesIds;
